import { FiPlay } from '@/components/react-icons/main/index.esm';
import IconV2 from '@/components/v2/IconV2';
import setQuery from '@/lib/setQuery';

export const exitReplayMode = () => {
  setQuery({ replayMode: null, replayStart: null, replayEnd: null });
};

const ReplayModeBanner = () => {
  return (
    <div className="replay-mode-banner">
      <IconV2 icon={FiPlay} size={13} />
      <span className="text">
        <b>Replay mode.</b> Choose the range of actions to run again — drag the handles or use Start / End on any action.
      </span>
      <span className="spacer" />
      <span className="exit" onClick={exitReplayMode}>
        Exit
      </span>
    </div>
  );
};

export default ReplayModeBanner;
